module.exports = __webpack_public_path__ + "img/lila.302bc43.jpg";